/**
 * WooCommerce platform adapter
 *
 * Registers the pmw.platform seam: the neutral surface the library core is
 * allowed to call. Everything behind it is WooCommerce/WordPress-specific.
 * A future FluentCart/SureCart harness registers its own object with the
 * same shape (the contract lives in docs/PLATFORM-CONTRACT.md).
 *
 * @since 1.65.0
 */

(function (pmw, $, undefined) {

	/**
	 * Wait until WooCommerce Blocks' wp.hooks global is available.
	 *
	 * @returns {Promise<void>}
	 */
	pmw.wpHooksExists = async () => new Promise(resolve => {
		(function waitForVar() {

			// Resolve if wp.hooks is defined
			if (typeof wp !== "undefined" && typeof wp.hooks !== "undefined") return resolve()
			setTimeout(waitForVar, 50)
		})()
	})

	/**
	 * Load the WooCommerce Blocks hook listeners as a chunk.
	 *
	 * Includes safeguard in case the user changed the default load order for
	 * wp-hooks, or removed it completely.
	 *
	 * @returns {Promise<void>}
	 */
	pmw.loadWcHooksFunctions = async () => {
		await pmw.wpHooksExists()
		await import(/* webpackChunkName: "wc-hooks" */ "./wc_hooks.js")
	}

	/**
	 * The neutral platform surface consumed by the library core and the
	 * pixel adapters. See docs/PLATFORM-CONTRACT.md.
	 */
	pmw.platform = {

		name: "woocommerce",

		/**
		 * Whether the shop's server-side cart session currently exists.
		 * WooCommerce marks it with the woocommerce_items_in_cart cookie.
		 *
		 * @returns {boolean}
		 */
		cartExists: () => pmw.doesWooCommerceCartExist(),

		/**
		 * Server-side cart content hash, used to detect carts changed
		 * outside client-side tracking. Empty string when unavailable.
		 *
		 * @returns {string}
		 */
		getCartHash: () => pmw.getCookie("woocommerce_cart_hash") || "",

		/**
		 * Product IDs of the products rendered in the current listing, in
		 * DOM order.
		 *
		 * @returns {string[]}
		 */
		getProductIdsOnPage: () => pmw.getProductIdsFromListing(),

		/**
		 * The main product id on a product detail page, or false.
		 *
		 * @returns {string|number|false|undefined}
		 */
		getMainProductId: () => pmw.getMainProductIdFromProductPage(),
	};

}(window.pmw = window.pmw || {}, jQuery));
